import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss'],
  standalone: true,
  imports: []
})
export class Page404Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
